const env = import.meta.env;
const requiredVariables: Array<string> = [
  /**
   * Add your required environment variables in here.
   */
  'VITE_DEPLOYMENT_TARGET',
  'VITE_API_URL',
  'VITE_STRIPE_PUBLISHABLE_KEY',
  'VITE_LANDING_APP_URL',
  'VITE_SUPPORT_APP',
  'VITE_AMPLITUDE_API_KEY',
  'VITE_USERWAY_ACCOUNT',
  'VITE_INTERCOM_ID',
  'VITE_CATCH_BACKEND_API_URL',
];

requiredVariables.forEach(function (name: string) {
  if (!env[name]) {
    throw Error(`Env variable "${name}" is not defined.`);
  }
});

// Sentry required for remote environments only
if (env.VITE_DEPLOYMENT_TARGET !== 'LOCAL') {
  const sentryVars = ['VITE_SENTRY_DSN'];
  sentryVars.forEach((name: string) => {
    if (!env[name]) {
      throw Error(`Env variable "${name}" is required for remote deployments.`);
    }
  });
}

function getEnv() {
  return env;
}

export default { getEnv };
